module.exports = __webpack_public_path__ + "img/ethan_mae.8344d873.png";